import React from "react";
import { OpEdit } from "../../assets/icons";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "../../components/MuiGenerals";
import { GridRenderCellParams } from "@mui/x-data-grid";
import {
  useZusDialogStore,
  useWithDrawApprovalSettingStore,
} from "../../zustand/store";
import { displayAmount, jsonParse } from "../../utils/helper";
import { useTranslation } from "../../hooks";
import { AddressBookOrder } from "src/views/AssetManagement/Swap/types";
import { IRegulationObject } from "src/zustand/types";
import { OperationType } from "@wallet-manager/node-types/dist/src/postgres/const";
const translatePrefix = "withdrawApprovalSetting";
interface IRecordWatchProps {
  params: GridRenderCellParams;
  configTime?: any;
}
const RenderDialog = ({ params, configTime }: IRecordWatchProps) => {
  //{- - Zustand- -}
  const useStore = useWithDrawApprovalSettingStore((state) => state);
  const zusDialog = useZusDialogStore();

  // const { email } = useAppSelector(selectProfile);
  const openDialogWindow = (
    e: React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    zusDialog.open("operationDialog");
    const targetRow = params.row;
    const { rawData } = targetRow;

    const getSendingAddress = (address: string): string[] => {
      if (!address) return [];
      const [notJSON, json] = jsonParse(address);
      console.log(notJSON, json);
      if (notJSON) return address.length ? [address] : [];
      return json;
    };

    const regulationMapping = (
      amtKey: "external_withdraw_amt" | "internal_withdraw_amt" | "swap_amt",
      array: any[],
    ) => {
      return array.map((item: IProps) => {
        const copyObj = { ...item };
        const newObj = { ...initRegulationFields };
        newObj[amtKey] = displayAmount(
          copyObj["amount"],
          rawData.decimal,
        ).replaceAll(",", "");
        newObj["approver_no"] = copyObj["approver_no"];
        newObj["sending_address"] = getSendingAddress(
          copyObj["sending_address"],
        );
        newObj["seq"] = copyObj["seq"];
        return newObj;
      });
    };

    const withdrawArr = regulationMapping(
      "external_withdraw_amt",
      rawData.withdraw_approval_regulations?.filter(
        (item: any) =>
          item.operation_type == OperationType.Withdraw && !item.wallet_type,
      ),
    );
    const settleMemetwArr = regulationMapping(
      "internal_withdraw_amt",
      rawData.withdraw_approval_regulations?.filter(
        (item: any) =>
          item.operation_type == OperationType.Withdraw && item.wallet_type,
      ),
    );
    const swapArr = regulationMapping(
      "swap_amt",
      rawData.withdraw_approval_regulations?.filter(
        (item: any) => item.operation_type == OperationType.Swap,
      ),
    );

    const currentRegulation = {
      externalWithdraw: withdrawArr.sort((a: any, b: any) => a.seq - b.seq),
      internalWithdraw: settleMemetwArr.sort((a: any, b: any) => a.seq - b.seq),
      swap: swapArr.sort((a: any, b: any) => a.seq - b.seq),
    };

    const dialogContent = {
      ...targetRow,
      rawData: {
        ...rawData,
        withdraw_approval_regulation: currentRegulation,
      },
    };

    useStore.setRecordForEdit({ ...dialogContent, configTime });
    useStore.setCurrentValues({
      editField: {
        field: "currentThreshold",
        value: rawData.threshold_amount,
      },
    });
    useStore.setCurrentValues({
      editField: {
        field: "curr_hourly_auto_approval_limit",
        value: rawData.hourly_auto_approval_limit,
      },
    });
    useStore.setCurrentValues({
      editField: {
        field: "currentRegulation",
        value: currentRegulation,
      },
    });
    useStore.setCurrentValues({
      editField: {
        field: "curr_mx_hourly_limit",
        value: rawData.mx_hourly_limit,
      },
    });
    useStore.setCurrentValues({
      editField: {
        field: "curr_mx_addr_hrly_count",
        value: rawData.mx_addr_hrly_count,
      },
    });
    useStore.setCurrentValues({
      editField: {
        field: "curr_mx_addr_hrly_limit",
        value: rawData.mx_addr_hrly_limit,
      },
    });
  };
  return (
    <>
      <IconButton type="edit" openDialogWindow={openDialogWindow} />
    </>
  );
};

export default RenderDialog;
// {--- - - -}
const IconButton = (p: {
  type: "edit";
  disabled?: boolean;
  openDialogWindow: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
}) => {
  const { tc } = useTranslation(translatePrefix);
  const sx = {
    box: {
      width: "2rem",
      cursor: p.disabled ? "" : "pointer",
      margin: "0 0.5rem",
      "&:hover": {
        filter: p.disabled ? "brightness(100%)" : "brightness(130%)",
      },
    },
    img: {
      filter: p.disabled ? "grayscale(100%)" : "grayscale(0)",
      width: "100%",
    },
  };
  const icon = {
    edit: { name: tc("edit"), url: OpEdit },
  }[p.type];
  // const permType = p.type === "re_broadcast" ? "re_broadcast" : p.type;
  // if (!hasPermission(permType)) return null;
  return (
    <Tooltip title={icon.name}>
      <Box sx={sx.box}>
        <img
          src={icon.url}
          onClick={(e) => !p.disabled && p.openDialogWindow(e)}
          style={sx.img}
          alt=""
        />
      </Box>
    </Tooltip>
  );
};
interface IProps {
  amount: any;
  id: string;
  seq: number;
  wallet_types: number;
  withdraw_approval_regulation_fk: number;
  withdraw_threshold_id: number;
  approver_no: string;
  sending_address: string;
}

export const initRegulationFields = {
  seq: 0,
  approver_no: "",
  external_withdraw_amt: "",
  internal_withdraw_amt: "",
  swap_amt: "",
  sending_address: [] as string[],
};
